var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.37 11.39V17.38C21.37 20.14 19.13 22.38 16.37 22.38H7.63C4.87 22.38 2.63 20.14 2.63 17.38V11.46C3.39 12.28 4.47 12.75 5.64 12.75C6.9 12.75 8.11 12.12 8.87 11.11C9.55 12.12 10.71 12.75 12 12.75C13.28 12.75 14.42 12.15 15.11 11.15C15.88 12.14 17.07 12.75 18.31 12.75C19.52 12.75 20.62 12.26 21.37 11.39Z",
    fill: "#FAEF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 1.25H8.99L8.25 8.61C8.19 9.29 8.29 9.93 8.54 10.51C9.12 11.87 10.48 12.75 12 12.75C13.54 12.75 14.87 11.89 15.47 10.52C15.65 10.09 15.76 9.59 15.77 9.08V8.89L14.99 1.25Z",
    fill: "#FABC82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 8.27L22.07 5.5C21.65 2.48 20.28 1.25 17.35 1.25H13.51L14.25 8.75C14.26 8.85 14.27 8.96 14.27 9.15C14.33 9.67 14.49 10.15 14.73 10.58C15.45 11.9 16.85 12.75 18.31 12.75C19.64 12.75 20.84 12.16 21.59 11.12C22.19 10.32 22.46 9.31 22.36 8.27Z",
    fill: "#8ED2F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59 1.25C3.65 1.25 2.29 2.48 1.86 5.53L1.59 8.28C1.49 9.35 1.78 10.39 2.41 11.2C3.17 12.19 4.34 12.75 5.64 12.75C7.1 12.75 8.5 11.9 9.21 10.6C9.47 10.15 9.64 9.63 9.69 9.09L10.47 1.26H6.59V1.25Z",
    fill: "#8ED2F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 16.66C10.08 16.79 9.12 17.87 9.12 19.15V22.38H14.87V19.5C14.88 17.41 13.65 16.42 11.35 16.66Z",
    fill: "#FABC82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopActive);
export default __webpack_public_path__ + "static/media/shop-active.58aa1816466023656f1cbec291d4798d.svg";
export { ForwardRef as ReactComponent };